var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"pro-nav-dropdown-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"pro-nav__shadow",style:({ height: `${_vm.height}px` })},[_c('div',{staticClass:"pro-nav__shadow-indicator",style:({ right: `${_vm.offset}px` })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }